import React, { useEffect, useState } from "react";
import _ from "underscore";
import MyDropDown from "../utility/myDropDown";
import t from "../../../helpers/t";
import usePricetariffs from "../hooks/usePricetariffs";

const uuid = _.uniqueId;

const PricesDropDown = ({ currentPrice, setCurrentPrice, select }) => {
  const { result, handleChange } = usePricetariffs({
    currentPrice,
    setCurrentPrice,
    select,
  });
  const [price, setPrice] = useState(null);
  const [initialized, setInitialized] = useState(false);
  if (result.pricesReducer.length > 0 && !initialized && select === "price") {
    if (typeof window.__temp_filter_pricetariff_id !== "undefined") {
      // Once set (i.e. display) location passed as URI-parameter
      setCurrentPrice(Number(window.__temp_filter_pricetariff_id));
      // caution: you can't remove the url filter immediately because setCurrentCity is not directly executed but a bit later during re-render
      // deleting the filter is done inside of the click handler (bugfix [#25066])
      //delete window.__temp_filter_location_id;
      setPrice(Number(window.__temp_filter_pricetariff_id));
    } else {
      if (select === "price") {
        console.log("we try to find", result.pricesReducer);
        // setCurrentPrice(Number(result.pricesReducer[0].id));
        setPrice(Number(result.pricesReducer[0].id));
        //handleChange({value:Number(result.citiesReducer[0].id)})
      }
      setInitialized(true);
    }
  }

  useEffect(() => {
    if (price !== null && initialized) {
      setCurrentPrice(price);
      handleChange({ value: price });
      setPrice(null);
    }
  }, [price, initialized]);

  return (
    <ul className="inb-vert-list">
      <span className="inb-list-title">{t("pricetariff", null, "capital")}</span>
      {result.pricesReducer.length > 0 && (
        <MyDropDown
          className="adjust"
          controlClassName="noBorders-noBackground"
          key={uuid()}
          options={result.pricesReducer.map((price, i) => {
            return { value: price.id, label: price.name, arrayId: i };
          })}
          onChange={handleChange}
          value={
            currentPrice === ""
              ? ""
              : result.pricesReducer.filter((price) => price.id === currentPrice)[0].name
          }
          placeholder={t("select_${a}", { a: t("pricetariff") })}
          type={"price"}
          setInit={setInitialized}
        />
      )}
    </ul>
  );
};

export default PricesDropDown;
